import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const MainBlock = styled.div`
  flex: 1 0 auto;
  width: 100%;
  height: 100%;
  align-items: stretch;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 15px;
`;
export const BodyBlock = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  height: 50px;
  flex: 0 0 auto;
  align-items: center;
  background-color: ${ColorSF2.paleBlue};
  padding: 0 10px;
  @media (max-height: 530px) {
    height: 30px;
  }
`;
export const Title = styled.div`
  display: flex;
  align-items: center;
`;
export const BoldText = styled.div`
  font-weight: bold;
`;
export const SearchOptionsWrapper = styled.div`
  margin-left: 60px;
  display: flex;
  font-size: 12px;
`;
export const SearchField = styled.input`
  margin-left: 8px;
  width: 200px;
  height: 20px;
  font-size: 14px;
  @media (max-height: 530px) {
    font-size: 12px;
  }
`;
export const CheckboxWrapper = styled.div`
  margin-left: 21px;
  display: flex;
  align-items: center;
`;
export const Checkbox = styled.div`
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const DefaultCheckbox = styled.input`
  display: none;
`;
export const CheckboxLabel = styled.label`
  margin-right: 8px;
  width: 20px;
  height: 20px;
`;

export const ListsWrapper = styled.div`
  width: 100%;
  height: calc(100% - 50px);
  @media (max-height: 530px) {
    height: calc(100% - 30px);
  }
`;
